import React, { useState } from "react";
import AnnualMaskCertificateUploadButton from "../Followup/AnnualMaskCertificateUploadButton";
import {
  getAnnualMaskSelectedSaleName,
  getAnnualMaskStatusConfig,
} from "../Followup/annualMaskPurchaseUtils";

const PAGE_SIZE = 5;

const DocumentLink = ({ label, file, emptyText, onViewFile, isPreviewLoading }) => (
  <div className="mb-2">
    <div className="small text-muted">{label}</div>
    {file ? (
      <button type="button" className="btn btn-link p-0 text-left"
        style={{ whiteSpace: "normal", overflowWrap: "anywhere", maxWidth: "100%" }}
        disabled={isPreviewLoading} onClick={() => onViewFile(file)}>
        <i className="fa fa-file-o mr-1" aria-hidden="true" />
        {file.fileName || label}
      </button>
    ) : <span className="text-muted small">{emptyText}</span>}
  </div>
);

const PatientAnnualMaskBatches = ({ cases, currentUser, onViewFile, onUploaded, isPreviewLoading = false }) => {
  const [page, setPage] = useState(1);
  const pageCount = Math.max(1, Math.ceil(cases.length / PAGE_SIZE));
  const currentPage = Math.min(page, pageCount);
  const start = (currentPage - 1) * PAGE_SIZE;
  const visibleCases = cases.slice(start, start + PAGE_SIZE);

  return (
    <div className="col-12 mb-4 d-flex">
      <div className="card border-0 pb-0 h-100 w-100">
        <div className="card-body">
          <h4 className="card-title mb-3">
            Annual Mask Purchase Batches <span className="badge badge-light ml-1">{cases.length}</span>
          </h4>
          {isPreviewLoading && <div className="small text-muted mb-2" role="status">Opening document...</div>}
          {cases.length ? (
            <>
              <div className="table-responsive">
                <table className="table table-sm table-striped mb-3"
                  aria-label="Annual Mask Purchase Batches" style={{ tableLayout: "fixed", minWidth: "720px" }}>
                  <thead>
                    <tr>
                      <th scope="col" style={{ width: "23%" }}>Batch / Follow-Up</th>
                      <th scope="col" style={{ width: "23%" }}>Mask / Sales</th>
                      <th scope="col" style={{ width: "23%" }}>Status / Sale Order</th>
                      <th scope="col" style={{ width: "31%" }}>Documents</th>
                    </tr>
                  </thead>
                  <tbody>
                    {visibleCases.map((caseItem) => {
                      const status = getAnnualMaskStatusConfig(caseItem.status);
                      const mask = caseItem.selectedMask || {};
                      const signedCertificate = caseItem.signedMedicalCertificate;
                      const batchName = caseItem.batchName || caseItem.batchId || "-";
                      return (
                        <tr key={caseItem.refPath || `${caseItem.batchId}-${caseItem.id}`} style={{ overflowWrap: "anywhere" }}>
                          <td className="align-top py-3">
                            <strong className="d-block text-truncate" title={batchName}>
                              {batchName}
                            </strong>
                            <div className="small text-muted mt-2">CPAP Follow-Up</div>
                            <div>{caseItem.sourceFollowupDate || "-"}</div>
                            <small className="text-muted">{caseItem.sourceFollowupType || "-"}</small>
                          </td>
                          <td className="align-top py-3">
                            <div>{mask.itemName || "-"}</div>
                            {mask.size && <small className="text-muted">Size: {mask.size}</small>}
                            <div className="small text-muted mt-2">Sales Representative</div>
                            <div>{getAnnualMaskSelectedSaleName(caseItem) || "-"}</div>
                          </td>
                          <td className="align-top py-3">
                            <span className={`badge badge-${status.badge}`} style={{ whiteSpace: "normal", textAlign: "left" }}>
                              {status.label}
                            </span>
                            <div className="small text-muted mt-2">Sale Order</div>
                            <div>{caseItem.saleOrderReceiptNo || "-"}</div>
                          </td>
                          <td className="align-top py-3">
                            <DocumentLink label="CPAP Usage Report" file={caseItem.usageReport}
                              emptyText="No report" onViewFile={onViewFile} isPreviewLoading={isPreviewLoading} />
                            <DocumentLink label={signedCertificate ? "Signed certificate" : "Generated form"}
                              file={signedCertificate || caseItem.generatedMedicalCertificate}
                              emptyText="No certificate" onViewFile={onViewFile} isPreviewLoading={isPreviewLoading} />
                            <AnnualMaskCertificateUploadButton caseItem={caseItem}
                              currentUser={currentUser} onUploaded={onUploaded} />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="d-flex flex-wrap justify-content-between align-items-center">
                <small className="text-muted mb-2" role="status">
                  {start + 1}–{Math.min(start + PAGE_SIZE, cases.length)} of {cases.length} records
                </small>
                {pageCount > 1 && (
                  <div className="d-flex align-items-center mb-2" aria-label="Annual Mask Purchase Batches pagination">
                    <button type="button" className="btn btn-outline-primary btn-sm"
                      disabled={currentPage === 1} onClick={() => setPage(currentPage - 1)}>Previous</button>
                    <span className="small mx-3">Page {currentPage} of {pageCount}</span>
                    <button type="button" className="btn btn-outline-primary btn-sm"
                      disabled={currentPage === pageCount} onClick={() => setPage(currentPage + 1)}>Next</button>
                  </div>
                )}
              </div>
            </>
          ) : <p className="text-muted mb-0">No Annual Mask Purchase batch</p>}
        </div>
      </div>
    </div>
  );
};

export default PatientAnnualMaskBatches;
